

<div class="row">
  <div class="col-md-10 col-10">
    <h3 mat-dialog-title >{{ 'CancelBooking' | translate }}</h3>
  </div>
  <div class="col-md-2 col-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>

<mat-dialog-content class="cancel-modal">

  <form name="form" [formGroup]="cancelForm" (ngSubmit)="cancelForm.valid && onSubmit()">
  <div class="row ">
    <div class="col-md-12">
      <p>{{ 'WeAreSorryToHear' | translate }}:</p>
    </div>
    <div class="col-md-8">
      <div class="form-group mb-0">

        <mat-form-field  appearance="none">
          <mat-select panelClass="select-cancel"  class="form-control select"
            formControlName="reasonId"
            placeholder="{{ 'Pleaseselectacancelationreason' | translate }}"
            [ngClass]="{'is-invalid':cancelForm.get('reasonId').touched && cancelForm.get('reasonId').invalid}" required
            data-placeholder="Select">
            <mat-option *ngFor="let reason of reasons" [value]="reason.value">
              {{reason.text}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="validation-height" >
        <div *ngIf ="showValidation">
          <div *ngIf="cancelForm.get('reasonId').errors?.required">
            <div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div>
          </div>
        </div>
      </div>
      
      
  


      <div class="form-group">
        <textarea  formControlName="comments" [ngClass]="{'is-invalid':cancelForm.get('comments').touched && cancelForm.get('comments').invalid}" placeholder="{{ 'AnyOtherComments' | translate }}" class="form-control" cdkAutosizeMinRows="3"></textarea>
      </div>
    </div>
    <div class="col-md-12">
      <p *ngIf="cancellationObj!=null && !isFreeCancellation">{{ 'CancelationFeesof' | translate }} {{cancellationObj.cancelationPercentage}}% {{ 'willbedeductedmsg' | translate }} ({{ cancellationObj.cancelationFee  | number }} {{currency}}) {{ 'asper' | translate }}  <span class="text-blue">{{ 'CancelationPolicy' | translate }}</span>
        {{ 'remainingDepositAmount' | translate }}.
      </p>
      <p *ngIf="isFreeCancellation">
        <!-- {{ 'NocancellationFeeswillbededucted,yourpaidamountwillberefundedbacktoyouraccount' | translate }} -->
        {{'NoCancelationFees' | translate}}
      </p>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12">
      <button type="submit" (click)="checkValid()"  class="btn default-btn mr-3" mat-button>{{ 'Confirm' | translate }}</button>
      <button type="reset" (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
    </div>

  </div>
</form>



</mat-dialog-content>






